import React, { createContext, useContext, useState } from 'react';

const PeriodContext = createContext();

export const usePeriod = () => useContext(PeriodContext);

export const PeriodProvider = ({ children }) => {
  const [selectedPeriod, setSelectedPeriod] = useState('all-time');
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const [showMissedTrades, setShowMissedTrades] = useState(false);
  const [selectedTag, setSelectedTag] = useState('all'); // Add to context

  return (
    <PeriodContext.Provider value={{ 
      selectedPeriod, 
      setSelectedPeriod, 
      selectedYear, 
      setSelectedYear, 
      selectedMonth, 
      setSelectedMonth,
      showMissedTrades,
      setShowMissedTrades,
      selectedTag,
      setSelectedTag
    }}>
      {children}
    </PeriodContext.Provider>
  );
};